import { H_RPQS_REFERENCIALS } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY } from '../../../../home/constants/RouteConstants'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import RpqsAction from 'rpqs/actions/RpqsAction'
import { Box } from '@mui/material'

const ManagementEntityRouter = () => {
    const dispatch = useDispatch()
    const { code } = useParams()

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `${PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY}${code}/dashboard`,
            habilitation: H_RPQS_REFERENCIALS,
        }, {
            icons: 'event',
            name: i18n.event,
            href: `${PATH_RPQS_REFERENCIAL_MANAGEMENT_ENTITY}${code}/event`,
            habilitation: H_RPQS_REFERENCIALS,
            hidden: code === 'new',
        }].filter(l => !l.hidden && componentHasHabilitations(l.habilitation))
    }, [code])

    useEffect(() => {
        if (code !== 'new') {
            dispatch(RpqsAction.fetchManagementUnitById(code))
        }
    }, [dispatch, code])

    return (
        <Box>
            <FixedSlideNav links={navLinks} />
            <Box className='content-page fullscreen' padding={1}>
                <BoundaryError>
                    <Outlet />
                </BoundaryError>
            </Box>
        </Box>
    )
}

export default ManagementEntityRouter